import { clothes } from 'dragGame.data'
import { playAudio } from '../audio/playAudio'
import { setState } from '../sprites/playSprite'

// get information from Draggable/Droppable event call
function getDragEventElements(e) {
  let dragContainer = e.data.dragEvent.data.sourceContainer
  let targetDropzone = e.data.dropzone
  let el = e.data.dragEvent.data.originalSource
  let sourceObj = el.getAttribute('data-object')
  let sourceDropzone = dragContainer.querySelector(`.dropzone[data-container="environment"][data-object="${sourceObj}"]`)
  let targetObj = targetDropzone.getAttribute('data-object')
  return {
    container: dragContainer,
    targetDropzone: targetDropzone,
    sourceDropzone: sourceDropzone,
    sourceObj: sourceObj,
    targetObj: targetObj,
    el: el
  }
}

function checkStatus() {
  let i = 0
  for (const [item] of Object.entries(clothes) ) {
    i++
    if(! clothes[item].placed) {
      return {
        nextItem: item,
        done: false
      }
    }
    else {
      if( Object.keys(clothes).length === i ) {
        return {
          done: true
        }
      }
    }
  }
}

let inSantaSlot = false

// fires when item hovers over a dropzone
// prevent dropping item into the wrong slot
function onDropRelease(e) {
  const data = getDragEventElements(e)
  inSantaSlot = false
  if( data.el.getAttribute('data-disabled') === "true" ) {
    if( data.targetDropzone.getAttribute('data-container') == 'santa' ) {
      inSantaSlot = true
    }
    e.cancel()
  }
  if( data.sourceObj !== data.targetObj ) {
    e.cancel()
  }
}

// fires after drop event is over
// if correct, mark placement as correct
// if ALL correct, run complete
function onDropStop(e, droppable, complete) {
  const data = getDragEventElements(e)
  if( inSantaSlot == true ) {
    playAudio('round1/sfx_incorrect')
  }
  if( data.sourceObj === data.targetObj && data.sourceDropzone !== data.targetDropzone ) {
    data.el.setAttribute('data-placed', true)
    data.targetDropzone.setAttribute('data-placed', true)
    clothes[data.sourceObj].placed = true
    let status = checkStatus()
    // if all are correct, run complete callback
    if(status.done) {
      playAudio( 'round1/sfx_correct' )
      setState('Santa', 'complete')
      complete()
    }
    else {
      setState('Santa', data.sourceObj)
      document.querySelector(`.object.${status.nextItem}`).setAttribute('data-disabled', 'false')
      playAudio( 'round1/sfx_correct' )
      playAudio( clothes[status.nextItem].vo )
    }
  }
  data.sourceDropzone.classList.remove('dragging')
}

// fires when item is initially picked up
// once dropped into place, prevent from moving again
function onDropStart(e) {
  inSantaSlot = false
  const data = getDragEventElements(e)
  data.el.setState('dragging')
  data.sourceDropzone.classList.add('dragging')
  if( data.el.getAttribute('data-placed') === "true" ) {
    e.cancel()
  }
}

export {onDropRelease, onDropStop, onDropStart}
